module.exports = __webpack_public_path__ + "static/media/undraw_code_thinking_1jeh.61a4c685.svg";